<template>
  <div class="emotional_distribution">
    <!-- 3. 情绪分布 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Region:</div>
            <el-select
              v-model="regionVal"
              clearable
              placeholder="Please choose"
              :popper-append-to-body="false"
              @change="changeArea"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :md="24" :lg="14">
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19" v-if="!isMyDate">
                  <el-date-picker
                    @blur="getStartDate"
                    type="date"
                    placeholder="Start date"
                    v-model="startDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsStart"
                  ></el-date-picker>
                  <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                  <el-date-picker
                    @blur="getEndDate"
                    type="date"
                    placeholder="End date"
                    v-model="endDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEnd"
                  ></el-date-picker>
                </el-col>
                <el-col :md="24" :lg="19" v-else>
                  <DatePicker
                    :startTime="startDate"
                    :endTime="endDate"
                    @startConfirm="startConfirm"
                    @endConfirm="endConfirm"
                    @startCancel="startCancel"
                    @endCancel="endCancel"
                    @startClear="startClear"
                    @endClear="endClear"
                  ></DatePicker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :md="24">
          <div class="option region_det clearfix">
            <div class="item_title">Select Region:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent(tag)"
              @close="handleClose(tag)"
              >{{ tag.value }}</el-tag
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <!-- 柱状图 -->
      <div class="col-md-6 pt-3 centre_sm_none echarts_container bar_style">
        <EBar
          :echartsData="echartsData"
          @onEveryBar="onEveryBar"
          :isNodata="isNodata"
        ></EBar>
      </div>
      <!-- 扇形图 -->
      <div class="col-md-6 pt-3 centre_sm_none echarts_container pie_style">
        <EPie
          :echartsData="pieData"
          :pieName="pieName"
          :isNopie="isNopie"
          :hoverData="hoverData"
        ></EPie>
      </div>
    </div>
  </div>
</template>

<script>
import titleTem from "./Title";
import EBar from "../echarts/EmotionalDistributionBar";
import EPie from "../echarts/EmotionalDistributionPie";
import {
  emotionalBarchart,
  listofCountries,
  emotionalPiechart,
} from "@/common/js/http/version3Api.js";

export default {
  name: "EmotionalDistribution",
  components: {
    titleTem,
    EBar,
    EPie,
  },
  data() {
    return {
      isMyDate: false,
      isNodata: false,
      isNopie: false,
      passTitleData: {
        titleName: "Emotion Distribution",
        commentTxt:
          "It refers to the emotion analysis of all content posted by foreign media about a brand, including positive, partial positive, neutral, partial negative, and negative, in regions. (Top 4 by the number of postings).",
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.endDate === "" || this.endDate !== "") {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return (
                time.getTime() < 1561910461 * 1000 ||
                time.getTime() > new Date(this.endDate).getTime()
              );
            }
          } else {
            let endDateVal = this.endDate;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.startDate === "") {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          } else {
            let beginDateVal = this.startDate;
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        },
      },
      //柱状图数据
      echartsData: [],
      // 饼状图数据
      pieName: "",
      //pieName:[],
      pieData: [],
      // 搜索条件
      regionVal: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      //点击的标签
      clickTruetag: [],
      countryArray: [],
      hoverData: {
        name: "U.S.A",
      },
    };
  },
  mounted() {
    if (document.documentElement.clientWidth < 768) this.isMyDate = true;
    else this.isMyDate = false;
    this.setDate();
    this.getlistofCountry();
    this.getBarChart();
    this.getPieChart();
    //this.clickBar()
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.clickTruetag.splice(this.clickTruetag.indexOf(tag.value), 1);
      this.options.filter((item) => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });

      this.regionVal = "";
      if (this.clickTruetag.length === 0) {
        this.pieName = "";
      } else {
        this.clickTruetag.map((item) => {
          this.pieName = item;
        });
      }

      this.getBarChart();
      this.getPieChart();
    },
    getStartDate(val) {
      this.getBarChart();
      this.getPieChart();
    },
    getEndDate() {
      this.getBarChart();
      this.getPieChart();
    },
    getContent(val) {
      this.getBarChart();
    },
    //获取国家列表
    getlistofCountry() {
      let data = {
        companyId: this.$route.query.id,
        brandToken: localStorage.getItem("brand-token"),
      };
      listofCountries(data).then((res) => {
        this.options = res.result;
        //this.dynamicTags = this.options;
        this.options.map((item) => {
          item.disabled = false;
          return item;
        });
      });
    },
    //柱壮图
    getBarChart() {
      if (this.startDate == null || this.startDate == "Invalid date") {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == "Invalid date") {
        this.endDate = "";
      }
      let data = {
        companyId: this.$route.query.id,
        regionalNames: this.clickTruetag,
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem("brand-token"),
      };

      emotionalBarchart(data).then((res) => {
        let newsArray = [];
        let one = newsArray.push(res.result.yAxis.data, res.result.series);
        this.$set(this.echartsData, "lineData", newsArray);
        this.echartsData = this.echartsData.lineData;
        if (this.echartsData[0].length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //选区国家列表
    changeArea(val) {
      this.pieName = val;
      this.clickState = true;
      this.options.filter((item) => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.clickTruetag.push(val);
        this.getBarChart();
        this.getPieChart();
      }
    },
    //点击柱状图
    onEveryBar(params) {
      this.pieName = params.name;
      this.hoverData = {
        name: params.name,
      };
      this.getPieChart();
    },
    //饼图
    getPieChart() {
      if (this.startDate == null || this.startDate == "Invalid date") {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == "Invalid date") {
        this.endDate = "";
      }
      let data = {
        companyId: this.$route.query.id,
        regionalNames: this.pieName,
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem("brand-token"),
      };
      emotionalPiechart(data).then((res) => {
        this.pieData = res.result.series[0].data;
        this.pieName = res.result.series[0].name;
        if (this.pieData.length === 0) {
          this.isNopie = true;
        } else {
          this.isNopie = false;
        }
      });
    },
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getPieChart()
        this.getBarChart()
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getPieChart()
        this.getBarChart()
      }
    },
  },
};
</script>

<style scoped>
.title {
  margin-top: 25px;
}
.echarts_container {
  display: inline-block;
}
.echarts_container > div {
  left: 0 !important;
  top: -20px;
  height: 370px !important;
}
@media screen and (max-width: 1024px) {
  .title {
    margin-top: 115px;
  }
  .echarts_container {
    margin-top: 80px !important;
  }
}
@media screen and (max-width: 768px) {
  .title {
    margin-top: 150px;
  }
  .echarts_container {
    margin-top: 30px !important;
  }
}
@media screen and (min-width: 968px) {
  .title {
    margin-top: 50px;
  }
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 123px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
@media screen and (max-width: 1024px) {
  .time .date_item {
    text-align: left !important;
  }
}
</style>
